// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__8tvnv","imageLogo":"home_imageLogo__A4imA","pulse":"home_pulse__P8xXJ"};